export default __webpack_public_path__ + "static/media/HindiDiwas6.c384d5ec.JPG";